module.exports = __webpack_public_path__ + "img/plan1M.6f6176a8.png";